import script from "./InputSections.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputSections.vue?vue&type=script&setup=true&lang=ts"

import "./InputSections.vue?vue&type=style&index=0&id=3cbd1e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cbd1e5a"]])

export default __exports__